import React from "react";
import HeroSection from "./HeroSection";
import AboutUs from "./AboutUs";
import Services from "./Services";
import WhyChooseUsPage from "./WhyChoose";
import GalleryPage from "./GalleryPage";
import HowItWorks from "./HowItWorks";
import SEOHead from "../../components/SEOHead";

function Home() {
  return (
    <div>
        <SEOHead />
      <HeroSection />
      <AboutUs />
      <Services />
      <GalleryPage />
      <HowItWorks />
      <WhyChooseUsPage />
    </div>
  );
}

export default Home;
